import { INITIAL_ZOOM, DEFAULT_CENTER } from '../constants/map';
import {
    FETCH_MACHINES_SUCCESS,
    FETCH_MACHINES_UPDATED_SUCCESS,
    SET_CENTER,
    SET_ZOOM,
    SET_MARKER,
    SET_LIST_MARKERS,
    SET_LIST_ACTIVE,
    SET_FILTER,
    SET_FILTERED_ITEMS,
    SET_USER_POS,
    SET_USER_POS_ERROR,
    SET_MAP,
    SET_INFOWINDOW,
    SET_EXTERNAL_GEOLOCATION,
    SET_SEARCH_VALUE,
    USER_POSITION_FETCHED,
    WEBSOCKET_MESSAGE_CHANGE,
    WEBSOCKET_MESSAGE_REMOVE,
    WEBSOCKET_MESSAGE_ADD,
    WEBSOCKET_URL,
    QUERY_MARKER_OPENED,
    SET_MAP_CONTAINER_DIMENSIONS
} from '../constants/actionTypes';

const initialState = {
    map: {},
    items: [],
    filteredItems: [],
    services: [],
    center: DEFAULT_CENTER,
    zoom: INITIAL_ZOOM,
    timestamp: 0,
    activeMarker: {},
    listMarkers: [],
    listActive: false,
    filter: [],
    userPos: null,
    externalGeolocation: false,
    fetchedMachines: false,
    fetchedUserPosition: false,
    socketUrl: null,
    infowindow: {},
    queryMarkerOpened: false,
    searchValue: '',
    mapContainerDimensions: {
        width: 500,
        height: 500
    }
};

export default function map(state = initialState, action) {
    let newItems;

    switch (action.type) {
        case WEBSOCKET_URL:
            return Object.assign({}, state, {
                socketUrl: action.payload
            });
        case WEBSOCKET_MESSAGE_ADD:
            return Object.assign({}, state, {
                items: [...state.items, action.payload],
            });
        case WEBSOCKET_MESSAGE_CHANGE:
            // Switch item in items with payload
            // where item.identifier == payload.identifier
            newItems = state.items.map(
                (item) => item.identifier === action.payload.identifier ? action.payload : item
            )

            // Update active marker if changed
            let activeMarker = state.activeMarker
            if (state.activeMarker.identifier === action.payload.identifier) {
                activeMarker = action.payload;
            }

            return Object.assign({}, state, {
                items: newItems,
                activeMarker,
            });
        case WEBSOCKET_MESSAGE_REMOVE:
            newItems = state.items.filter(
                (item) => item.identifier !== action.payload.id
            )

            return Object.assign({}, state, {
                items: newItems,
            });
        case FETCH_MACHINES_UPDATED_SUCCESS:
            return Object.assign({}, state, {
                items: action.data,
                timestamp: action.timestamp
            });
        case FETCH_MACHINES_SUCCESS:
            return Object.assign({}, state, {
                items: action.data,
                timestamp: action.timestamp,
                fetchedMachines: true
            });
        case SET_CENTER:
            return Object.assign({}, state, {
                center: action.center
            });
        case SET_ZOOM:
            return Object.assign({}, state, {
                zoom: action.zoom
            });
        case SET_MARKER:
            return Object.assign({}, state, {
                activeMarker: action.activeMarker
            });
        case SET_LIST_MARKERS:
            return Object.assign({}, state, {
                listMarkers: action.listMarkers
            });
        case SET_LIST_ACTIVE:
            return Object.assign({}, state, {
                listActive: action.listActive
            });
        case SET_FILTER:
            return Object.assign({}, state, {
                filter: action.filter
            });
        case SET_FILTERED_ITEMS:
            return Object.assign({}, state, {
                filteredItems: action.filteredItems
            });
        case SET_USER_POS:
            return Object.assign({}, state, {
                userPos: action.userPos
            });
        case SET_USER_POS_ERROR:
            return Object.assign({}, state, {
                userPosError: action.error,
            });
        case SET_MAP:
            return Object.assign({}, state, {
                map: action.map
            });
        case SET_INFOWINDOW:
            return Object.assign({}, state, {
                infowindow: action.infowindow
            });
        case SET_EXTERNAL_GEOLOCATION:
            return Object.assign({}, state, {
                externalGeolocation: action.externalGeolocation
            });
        case SET_SEARCH_VALUE:
            return Object.assign({}, state, {
                searchValue: action.searchValue
            });
        case USER_POSITION_FETCHED:
            return Object.assign({}, state, {
                fetchedUserPosition: true
            });
        case QUERY_MARKER_OPENED:
            return Object.assign({}, state, {
                queryMarkerOpened: true
            });
        case SET_MAP_CONTAINER_DIMENSIONS:
            return Object.assign({}, state, {
                mapContainerDimensions: action.dimensions
            });
        default:
            return state;
    }
}
